import React from 'react';
import { EvalAnswers, EvalOption, Tags } from '../common/page-data';
import { TagsAvoid } from '..';
import Grid from '@mui/material/Grid';
import { TagListAnswer } from './tag-list-answer';
interface ComponentProps {
  tags: TagsAvoid;
  evalAnswers: EvalAnswers;
  onChange?: (evalAnswers: EvalAnswers) => void;
  disabled?: boolean;
}

type Props = ComponentProps;

const TagListComp: React.FC<Props> = (props) => {
  const { tags, evalAnswers, disabled } = props;

  const onChange = (id: string, answer: EvalOption) => {
    if (props.onChange) {
      const newEvalAnswers = { ...evalAnswers };
      newEvalAnswers[id] = answer;
      props.onChange(newEvalAnswers);
    }
  };

  return (
    <Grid container sx={{ ml: 3 }} spacing='5'>
      {Object.values(tags).map((tag) => (
        <TagListAnswer
          key={tag.id}
          tagText={tag.reason.gerund}
          reasonText={tag.avoidReason}
          evalOption={evalAnswers[tag.id]}
          onChange={(answer: EvalOption) => onChange(tag.id, answer)}
          disabled={disabled}
        />
      ))}
    </Grid>
  );
};

//******************************************************************************
export const NegativeTagList = TagListComp;
